import Vue from 'vue';
import App from './App';
import Vuetify from 'vuetify';
import router from './router';
import store from './store';

import 'font-awesome/css/font-awesome.css';
import './theme/default.styl';
import VeeValidate from 'vee-validate';
import Truncate from 'lodash.truncate';

// import Vue2Leaflet from 'vue2-leaflet';
import * as Vue2Leaflet from 'vue2-leaflet'; // VALID
import 'leaflet.markercluster';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';

import 'leaflet-rotatedmarker';
import 'leaflet/dist/leaflet.css';

import '@/utils/googleapis/googlemap.js';
import '@/utils/googleapis/googlefonts.css';

if (window.location.href.includes('location') || window.location.protocol.includes('https')) import('./register-service-worker');

Vue.config.productionTip = false;
Vue.filter('truncate', Truncate);
Vue.use(VeeValidate, { fieldsBagName: 'formFields' });

Vue.use(Vuetify, {
  options: {
    themeVariations: ['primary', 'secondary', 'accent'],
    extra: {
      mainToolbar: {
        color: 'primary'
      },
      sideToolbar: {},
      sideNav: 'primary',
      mainNav: 'primary lighten-1',
      bodyBg: ''
    }
  },
  Vue2Leaflet,
});

// eslint-disable-next-line
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});


// WEBPACK FOOTER //
// ./src/main.js